<div class="flex flex-col h-full">
  <elcia-title [iconType]="'todo'" [title]="'entity.todos' | translate"/>
  <div class="flex justify-between">
    <div class="flex w-1/5">
      <elcia-search [control]="todoFilterForm.controls.searchText"/>
    </div>

    <div class="flex gap-2">
      <div>
        <elcia-button (onClick)="toggleFilterDisplayed()" [icon]="'filter'" [label]="'app.filters' | translate"
                      [severity]="this.isFilterDisplayed() ? 'primary' :'secondary'"/>
      </div>
      <div (click)="colPicker.toggle($event)">
        <elcia-button [icon]="'columns'" [label]="'app.colonnes' | translate"
                      [severity]="'secondary'"/>
      </div>
      <div>
        <elcia-ai-button (onClick)="isAiChatDisplayed.set(true)"
                         [label]="'ai.chat-open' | translate"/>
      </div>
      <div>
        <elcia-button (onClick)="showForm(true)" [icon]="'plus'" [label]="'action.add-todo' | translate"/>
      </div>
    </div>
  </div>

  <p-popover #colPicker>
    <div class="flex flex-col min-w-44">
      @for (status of statuses(); track status.id) {
        <div (click)="toggleStatusVisibility(status.id!)"
             class="hover:bg-primary-50 flex items-center gap-3 px-3 py-2 cursor-pointer hover:bg-surface-100 rounded select-none">
          <elcia-dot [color]="status.color ?? '#94a3b8'"/>
          <span class="text-sm flex-1">{{ status.name }}</span>
          @if (!hiddenStatusIds().includes(status.id!)) {
            <i class="pi pi-check text-xs text-primary-500"></i>
          }
        </div>
      }
    </div>
  </p-popover>
  @if (this.isFilterDisplayed()) {
    <elcia-filter-container>
      <elcia-user-dropdown [control]="todoFilterForm.controls.createdByIds" [isMulti]="true" [label]="'author'"/>
      <elcia-user-dropdown [control]="todoFilterForm.controls.assignedToIds" [isMulti]="true" [label]="'assigned'"/>
      <elcia-party-dropdown [control]="todoFilterForm.controls.clientIds" [isMulti]="true"
                            [partyTypes]="this.partyTypes()"/>
      <elcia-todo-priority-dropdown [control]="todoFilterForm.controls.priorities" [isMulti]="true"/>
      <elcia-todo-state-dropdown [control]="todoFilterForm.controls.states" [isMulti]="true"/>

    </elcia-filter-container>
  }

  @if (isLoading()) {
    <elcia-loader/>
  } @else {
    <div class="flex-1 overflow-hidden">
      <elcia-todo-kanban
        (onAddTodo)="addTodoWithStatus($event)"
        (onChildCompletionChange)="toggleChildCompletion($event)"
        (onCompletionChange)="toggleCompletion($event)"
        (onEdit)="editTodo($event)"
        (onStatusChange)="onStatusChange($event)"
        [hiddenStatusIds]="hiddenStatusIds()"
        [highlightChildId]="highlightChildId()"
        [highlightTodoId]="highlightTodoId()"
        [todoStatuses]="statuses()"
        [todos]="todos()"
      />
    </div>
  }
</div>

@if (isFormDisplayed()) {
  <elcia-dialog
    (onAction)="onDialogSave()"
    (onClose)="closeForm()"
    (onDelete)="deleteTodo()"
    [isActionLoading]="isFormSaving()"
    [mustDisplayDeleteButton]="this.selectedTodoFormValue() !== undefined"
    [size]="selectedTodoFormValue() ? 'large' : 'medium'"
    [title]="'entity.todo' | translate">

    @if (isLoadingSelectedTodo()) {
      <elcia-loader/>
    } @else {
      <elcia-todo-form
        (onSubmit)="onFormSubmit($event)"
        [documents]="selectedTodoDocuments()"
        [initialValue]="formInitialValue()"
        [completedAt]="selectedTodoCompletedAt()"
        [isAuthor]="isAuthor()"
        [storeTodos]="storeTodos()"
        [users]="users()"
      />
    }
  </elcia-dialog>
}

@if (isAiChatDisplayed()) {
  <elcia-dialog
    (onClose)="isAiChatDisplayed.set(false)"
    [mustDisplayActionButton]="false"
    [mustDisplayCancelButton]="false"
    [size]="'medium'"
    [title]="'ai.chat-title' | translate">
    <elcia-ai-chat/>
  </elcia-dialog>
}
